export default "/img/VI.3e2c33f1fa7de0c23da5cae0f9f3158c.png";